import React, { useState, useEffect, useRef } from "react";
import ExternalActionsTable from "src/components/ExternalActionsTable";
import SelectForm from "../../../components/ComponentesFormularios/SelectForm";
import InputForm from "../../../components/ComponentesFormularios/InputForm";
import { Colors } from "../../../assets/colors/Colors";
import AgGridTable from "src/components/AgGridTable";
import Tooltip from "@mui/material/Tooltip";
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import RadioButtonForm from "../../../components/ComponentesFormularios/RadioButtonForm";
import { CalendarForm, CalendarFormRange } from "../../../components/ComponentesFormularios/CalendarForm";
import { modalCRUDService } from "../../../services/modalCRUDService";
import { GlobalConstants } from "../../../data/GlobalConstants";
import { useDispatch, useSelector } from "react-redux";
import ImagePicker from "src/components/ComponentesFormularios/ImagePicker";
import TransfertList from "../../../components/TransferList";
import AutocompleteForm from "src/components/ComponentesFormularios/Autocomplete";
import {
    convertToString,
    dateToStringFormat, getDateTime,
    getFechaToCalendarRange,
    validarEspaciosEnBlanco,
    validArray,
    currencyFormatter
} from "../../../util/functions";
import { FormProvider, useForm, useFormContext, useWatch } from "react-hook-form";
import { isEmpty, isObject } from "../../../util/is";
import SelectFormVirtualize from "../../../components/ComponentesFormularios/SelectFormVirtualize";
import {
    classResponsiveForm,
    classResponsiveFormDoubleWidthHeader,
    classResponsiveFormDoubleWidth, classResponsiveFormWidthHeader, ERRORFIELDREQUIRED,
    optionsEstados,
    optionsYesNo
} from "../../../data/ConstantForm";
import NestedSelectVirtualizeForm from "../../../components/ComponentesFormularios/NestedSelectVirtualizeForm";
import { crearActivosService } from "src/services/apiCrearActivos";
import { preciosService } from "src/services/apiPrecios";
import Precios from "src/views/pages/gestion-maestros/precios/Precios";

const columnsDef = [
    { headerName: '', field: 'check', resizable: false, sortable: false, filter: false, width: 10, checkboxSelection: true, headerCheckboxSelection: true},
    { headerName: 'ID', field: "id", resizable: true, sortable: false, filter: false, width: 10, hide: true  },
    { headerName: 'Estructura', field: "linea", resizable:true, sortable: true, filter: true, width:40},
    { headerName: 'ID Nivel', field: "nivel", resizable: true, sortable: true, filter: true, width: 40},
    { headerName: 'ID Oficina', field: "ofiVentas", resizable: true, sortable: true, filter: true, width: 40 },
    { headerName: 'ID Agente', field: "agenteComercial", resizable: true, sortable: true, filter: true, width: 40 },
    { headerName: 'ID Canal', field: "canal", resizable: true, sortable: true, filter: true, width: 40 },
    { headerName: 'SubCanal', field: "subCanal", resizable: true, sortable: true, filter: true, width: 40 },
    { headerName: 'Tipologia', field: "tipologia", resizable: true, sortable: true, filter: true, width: 40 },
    { headerName: 'Producto', field: "producto", resizable: true, sortable: true, filter: true, width: 40 },
    { headerName: 'Precio', field: "precio", resizable: true, sortable: true, filter: true, width: 40},
    { headerName: 'Fecha Inicial Actual', field: "fechaIniOld", resizable: true, sortable: true, filter: true, width: 40, cellStyle: {background: '#FAEDE6', flex: 1, alignItem: 'center', justifyContent: 'center'}  },
    { headerName: 'Fecha Final Actual', field: "fechaFinOld", resizable: true, sortable: true, filter: true, width: 40, cellStyle: {background: '#FAEDE6', flex: 1, alignItem: 'center', justifyContent: 'center'} },
    { headerName: 'Fecha Inicial Recomendada', field: "fechaIni", resizable: true, sortable: true, filter: true, width: 40, cellStyle: {flex: 1, alignItem: 'center', justifyContent: 'center'} },
    { headerName: 'Fecha Final Recomendada', field: "fechaFin", resizable: true, sortable: true, filter: true, width: 40, cellStyle: {flex: 1, alignItem: 'center', justifyContent: 'center'} },
    { headerName: 'Usr Auditor', field: "auditor", resizable: true, sortable: true, filter: true, minWidth: 55 },
    { headerName: 'Fecha Auditoria', field: "fechaAuditoria", resizable: true, sortable: true, filter: true, minWidth: 55 },
]

const TableIntegridad = ({properties}) => {

    const {data} = properties
    const [stateButton, setStateButton] = useState(false);
    const dispatch = useDispatch()
    const authState = useSelector(state => state.auth)
    const { idUsuario } = authState;
    const tableRef = useRef(null);
    const countMateriales = useRef(null);
    const integridadRef = useRef(null);

    const guardarDatos = async () =>{
        let arrSave = []
        let selected = false;
        setStateButton(true)

        tableRef.current.api.forEachNodeAfterFilter(nodo =>{
            if(nodo.selected){
                nodo.data.ac = 'A'
                nodo.data.idUsuario = idUsuario;
                arrSave.push(nodo.data)
                selected = true;
            }
        })

        if(!selected){
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning, message: 'Selecciona los registros que desea corregir' } });
        }else{
            try{

                let res = await preciosService.guardarCargueExcel(arrSave)
                const { status, msg, data: datos } = res
    
                if(status){
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: ` Reglas actualizadas: ${arrSave.length}`  } });
                    modalCRUDService.clear()
    
                }else{
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: 'Ha ocurrido un error' } });
                }
    
    
            }catch(e){
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: e } });
                console.log(e);
            }
        } 
    }

    useEffect( () => {
        integridadRef.current.innerText = data.countIntegridad == undefined ? ' 0' : ` ${data.countIntegridad}`
        countMateriales.current.innerText = data.countMateriales == undefined ? ' 0' : ` ${data.countMateriales}`
    }, [])

    const onGridReady = (params) => {
        const allColumns = [];
        params.columnApi.getAllColumns().map( column =>{
            allColumns.push(column.colId)
        })
        params.columnApi.autoSizeColumns(allColumns, false);
    }

  return (
  <>
    <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex justify-content-between align-items-center w-50 pl-3">
            <div>
                <strong>Integridad de reglas:</strong>
                <span ref={integridadRef} style={{fontSize: 20, color: '#4040FF', fontWeight: 'bold'}}> 0</span>
            </div>
            <div>
                <strong>Materiales afectados por regla: </strong>
                <span ref={countMateriales} style={{fontSize: 20, color: 'green', fontWeight: 'bold'}}> 0</span>
            </div>
        </div>
        <div className={`d-flex align-items-center ${stateButton ? 'is-disabled' : ''}`}>
            {/* <Tooltip title="Cancelar" aria-label="cancelar">
                <a onClick={() => { modalCRUDService.clear() }} className="icon-container-actions d-flex">
                    <div style={{ backgroundColor: Colors.RED_SWITCH_INACTIVE }} />
                    <i style={{ color: Colors.RED_SWITCH_INACTIVE }} className="fas fa-times fa-2x" />
                </a>
            </Tooltip> */}
            <ExternalActionsTable
                accionVisibilidadColumnas={tableRef}
            />
            <Tooltip title="Guardar Producto" aria-label="guardar-producto">
                <a className="icon-container-actions d-flex "
                onClick={() => guardarDatos() }>
                    <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                    <i style={{color: Colors.COLOR_GREEN_DARK}} className="far fa-save fa-2x"/>
                </a>
            </Tooltip>
        </div>
    </div>
    <AgGridTable
        referencia={tableRef}
        columnDef={columnsDef}
        dataList={data?.rows || []}
        rowSelection={'multiple'}
        avatarKey={'nombre'}
        onGridReady={onGridReady}
        
        
    />
  </>
  )
};

export default TableIntegridad;
